export type FeatureLimitData = {
  feature: string;
  limit: number;
  used: number;
  message: string;
};

export function dispatchFeatureLimitEvent(data: FeatureLimitData) {
  window.dispatchEvent(
    new CustomEvent("feature-limit-reached", { detail: data })
  );
}
